export const greetingKeys = {
    TOMATO: 'tomato',
    CUPCAKE: 'cupcake',
}
